import { useEffect, useRef } from "react";

export const attributeToBoolean = (attr?: boolean | null | string): boolean => {
    return attr !== undefined;
};

export const stringToBoolean = (value: string | undefined): boolean => {
    return value === "true";
};

/**
 * Check if a prop exists
 * @param prop
 * @returns {boolean}
 */
export const checkPropExistence = (prop: any): boolean => {
    return prop !== false && prop !== undefined;
};

export const usePreviousAttributeValue = <T>(value: T): T | undefined => {
    const ref = useRef<T>(undefined);

    useEffect(() => {
        ref.current = value;
    }, [value]);

    return ref.current;
};
